import {
    Component,
    Inject,
    OnInit,
    ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
    MyErrorStateMatcher,
    passwordMatchValidator,
    strongPasswordValidator
} from '../add-user/form-validators';
import { CommonModule } from '@angular/common';
import { ErrorStateMatcher } from '@angular/material/core';
import { UsersService } from '../users-service/users.service';
import { GrpcStatusEvent } from '@ngx-grpc/common';
import { AuthService } from '../../../authentication/service/auth.service';
import { ResetPasswordRequest } from '../../../protos/generated/admin.pb';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-reset-password',
    imports: [
        MatDialogModule,
        MatButtonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        CommonModule,
        TranslatePipe
    ],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [{ provide: ErrorStateMatcher, useClass: MyErrorStateMatcher }]
})
export class ResetPasswordComponent implements OnInit {
    resetPasswordForm!: FormGroup;
    matcher = new MyErrorStateMatcher();
    hidePassword: boolean = true;
    hidePasswordConfirm: boolean = true;
    errorMessage: string = '';
    successAlert: boolean = false;
    isLoading: boolean = false;

    constructor(
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private usersService: UsersService,
        private authService: AuthService,
        private dialogRef: MatDialogRef<ResetPasswordComponent>
    ) {}
    ngOnInit(): void {
        this.resetPasswordForm = this.fb.group(
            {
                password: ['', [Validators.required, strongPasswordValidator]],
                confirmPassword: ['', Validators.required]
            },
            { validator: passwordMatchValidator }
        );
    }

    onResetPassword() {
        this.isLoading = true;
        const resetPasswordRequest = new ResetPasswordRequest();
        resetPasswordRequest.id = this.data;
        resetPasswordRequest.password = this.resetPasswordForm.get(
            'password'
        )?.value;
        resetPasswordRequest.confirmPassword = this.resetPasswordForm.get(
            'confirmPassword'
        )?.value;
        this.usersService.resetPassword(resetPasswordRequest).subscribe({
            next: () => {
                this.successAlert = true;
            },
            error: (error: GrpcStatusEvent) => {
                if (error.statusCode === 16) {
                    this.authService.logOut();
                } else {
                    this.errorMessage = error.statusMessage;
                }
            },
            complete: () => {
                this.isLoading = false;
                setTimeout(() => {
                    this.dialogRef.close();
                }, 3000);
            }
        });
    }

    closeAlert() {
        this.errorMessage = '';
        this.successAlert = false;
    }
}
